export var FlowStepShapeType;
(function (FlowStepShapeType) {
    FlowStepShapeType[FlowStepShapeType["Circle"] = 0] = "Circle";
    FlowStepShapeType[FlowStepShapeType["Diamond"] = 1] = "Diamond";
    FlowStepShapeType[FlowStepShapeType["Square"] = 2] = "Square";
    FlowStepShapeType[FlowStepShapeType["TriangleLeft"] = 3] = "TriangleLeft";
    FlowStepShapeType[FlowStepShapeType["TriangleRight"] = 4] = "TriangleRight";
    FlowStepShapeType[FlowStepShapeType["Waypoint"] = 7] = "Waypoint";
    FlowStepShapeType[FlowStepShapeType["Form"] = 8] = "Form";
    FlowStepShapeType[FlowStepShapeType["Flow"] = 9] = "Flow";
    FlowStepShapeType[FlowStepShapeType["RuleSet"] = 10] = "RuleSet";
    FlowStepShapeType[FlowStepShapeType["Image"] = 11] = "Image";
    FlowStepShapeType[FlowStepShapeType["Task"] = 12] = "Task";
    FlowStepShapeType[FlowStepShapeType["Page"] = 13] = "Page";
    FlowStepShapeType[FlowStepShapeType["NewSquare"] = 14] = "NewSquare";
    FlowStepShapeType[FlowStepShapeType["SimpleCircle"] = 50] = "SimpleCircle";
    FlowStepShapeType[FlowStepShapeType["SimpleRectangle"] = 51] = "SimpleRectangle";
    FlowStepShapeType[FlowStepShapeType["SimpleTriangleLeft"] = 52] = "SimpleTriangleLeft";
    FlowStepShapeType[FlowStepShapeType["SimpleTriangleRight"] = 53] = "SimpleTriangleRight";
    FlowStepShapeType[FlowStepShapeType["SimpleTriangleUp"] = 54] = "SimpleTriangleUp";
    FlowStepShapeType[FlowStepShapeType["SimpleTriangleDown"] = 55] = "SimpleTriangleDown";
    FlowStepShapeType[FlowStepShapeType["ArrowLeft"] = 56] = "ArrowLeft";
    FlowStepShapeType[FlowStepShapeType["ArrowRight"] = 57] = "ArrowRight";
    FlowStepShapeType[FlowStepShapeType["ArrowUp"] = 58] = "ArrowUp";
    FlowStepShapeType[FlowStepShapeType["ArrowDown"] = 59] = "ArrowDown";
    FlowStepShapeType[FlowStepShapeType["SimpleDiamond"] = 60] = "SimpleDiamond";
    FlowStepShapeType[FlowStepShapeType["Cylinder"] = 61] = "Cylinder";
    FlowStepShapeType[FlowStepShapeType["Cube"] = 62] = "Cube";
    FlowStepShapeType[FlowStepShapeType["None"] = 63] = "None";
    FlowStepShapeType[FlowStepShapeType["SimpleFlowShape"] = 64] = "SimpleFlowShape";
    FlowStepShapeType[FlowStepShapeType["DMNDecision"] = 65] = "DMNDecision";
    FlowStepShapeType[FlowStepShapeType["DMNBusinessKnowledge"] = 66] = "DMNBusinessKnowledge";
    FlowStepShapeType[FlowStepShapeType["DMNInputData"] = 67] = "DMNInputData";
    FlowStepShapeType[FlowStepShapeType["DMNKnowledgeSource"] = 68] = "DMNKnowledgeSource";
})(FlowStepShapeType || (FlowStepShapeType = {}));
;
